export default __webpack_public_path__ + "static/media/user-icon.2cb40d9f.jpeg";